export const scriptId = 'captcha-script';
